import React from "react";

export default function Container({
  children,
  className = "",
  size = "default",
}: {
  children: React.ReactNode;
  className?: string;
  size?: "default" | "narrow" | "wide";
}) {
  const widths = {
    narrow: "max-w-4xl",
    default: "max-w-6xl",
    wide: "max-w-7xl",
  };
  return (
    <div className={`relative mx-auto w-full px-5 sm:px-6 lg:px-8 ${widths[size]} ${className}`}>
      {children}
    </div>
  );
}
